import React, { useEffect } from 'react'
import { useParams } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'

import AssetGroupsList from './AssetGroupsList'
import PageSectionHeader from '../../../../../features/components/PageSectionHeader'
import GoogleAssetGroupEdit from '../../../../../forms/Google/AdForms/GoogleAssetGroup/GoogleAssetGroupEdit'
import AssetGroupsChangeHistory from './AssetGroupsChangeHistory'
import Can from '../../../../../features/components/Can'

import { getAssetGroups, clearAssetGroups } from '../../../../../modules/actions/assets'
import { selectedGoogleAdAccountSelector } from '../../../../../modules/selectors/adAccounts'

const AssetGroups = () => {
  const dispatch = useDispatch()

  const { campaign_id } = useParams()

  const { id: googleAdAccountId } = useSelector(selectedGoogleAdAccountSelector)

  useEffect(() => {
    dispatch(
      getAssetGroups({
        account: googleAdAccountId,
        campaign: campaign_id
      })
    )
  }, [dispatch, campaign_id, googleAdAccountId])

  useEffect(() => {
    return () => {
      dispatch(clearAssetGroups())
    }
  }, [dispatch])

  return (
    <>
      <PageSectionHeader title="Asset Groups" />
      <AssetGroupsList />

      <Can I="update" a="Ad">
        <GoogleAssetGroupEdit />
      </Can>
      <AssetGroupsChangeHistory />
    </>
  )
}

export default AssetGroups
